// extracted by mini-css-extract-plugin
module.exports = {"input_wrapper":"style_input_wrapper__PiFYR","label":"style_label__IO5Jx"};